import { store } from 'Store/store.index';
import intl from 'react-intl-universal';
import { UTCTimeFormat } from 'Utils/utils';
import { fileController } from 'Components/viewer/Controllers/index';
import { collaborationService } from 'Store/services/Collaboration/index';
import { message } from 'antd';
import { getFileBufferByUrl } from '@/api/download.api';
import fileExit from 'Utils/FileExist';
import { getFileInfoFromTeams } from '@/modules/msTeams/services/fetchFile';
import { uploadFileFromTeams } from '@/modules/msTeams/services/uploadFile';
import { locateCommentFromNotification } from '@/modules/msTeams/services/locateAnnot';
import { thirdPartyService } from '.';
import { START_SHARE_DOC } from 'Components/viewer/ui/constants/collaboration.constants';

const messageKey = "loadingCollaborationMode"

class TeamsAppService {
  async enterCommenting() {
    store.appStore.doUpdateDocModified(false)
    const fileData = await collaborationService.openSharedFileForTeamsApp();
    uploadFileFromTeams(fileData).catch(() => {
      store.appStore.setGlobalMessage({ type: 'error', content: intl.formatMessage({ id: 'UploadingFile.fail' }) });
    })
    let sidebar = await window.pdfui.getComponentByName('comment-list-sidebar-panel');
    sidebar.active();
  }
  async autoEnterCommenting(extDocID, currentDocHash) {
    try {
      store.appStore.showLoading(true)

      const checkAnnotFormPermission = await fileController.checkAnnotFormPermission();

      if (checkAnnotFormPermission === 0) {
        store.appStore.showLoading(false);
        message.error({content: intl.get('collaboration.Dlg.noPermission'), key: messageKey, duration: 2})
        store.teamsAppStore.loading.show({progress: 100})

        return;
      }
    } catch (error) {
      store.appStore.showLoading(false);
      message.destroy();
      console.log('===>>> ~ TeamsAppService ~ autoEnterCommenting ~ error', error);
    }

    // 无记录，则为当前用户创建协作文档
    const createShareFileLinkForTeamsApp = async () => {
      try { 
        
        // 过期用户不允许创建共享
        const { isDashboardTrial } = store.accountStore;
        
        if (!isDashboardTrial && (!await store.userStore.hasSubscribePermission())) {
          store.appStore.showLoading(false);
          message.destroy();
          store.teamsAppStore.loading.show({progress: 100})

          return ;
        }

        const sendData = {
          deadline: '',
          prohibitComment: 0,
          extDocID,
          extDocHash: currentDocHash
        };
        
        await store.collaborationStore.createShareFileLinkForTeamsApp(sendData);
        await this.enterCommenting();
        store.appStore.showLoading(false);
        store.appStore.setCollaborationMode();
        // message.success({ content: "Enter collaboration mode", key: messageKey, duration: 2 })
      } catch (error) {
        await this.failureCallbackOfCreateShareFile(error, extDocID, currentDocHash);
      }
    }

    // 需要等待获取账户订阅权限接口返回后才能发起共享
    let timer, date = Date.now();

    timer = setInterval(() => {
      if (store.userStore.isEnterpriseUser || store.accountStore.subscriptionState) {
        clearInterval(timer);
        createShareFileLinkForTeamsApp();
      }
      if ((Date.now() - date) > 60000) {
        console.error('===>>> ~ createShareFileLinkForTeamsApp timeout ~');
        message.error({ content: "Collaboration service timeout, please confirm whether the network is normal?", key: messageKey, duration: 0 })
        clearInterval(timer);
        store.teamsAppStore.loading.show({progress: 100})
      }
    }, 1000);
  }

  async failureCallbackOfCreateShareFile(error, extDocID, currentDocHash) {
    if(error.source === 'fileSizeOver') {
      store.appStore.showLoading(false);
      const errorMsg = intl.get('collaboration.Dlg.FileExceededSize', { fileSize: 30 });
      // store.collaborationStore.postErrorMsg({ type: 'error', errorInfo: errorMsg });
      message.error({content: errorMsg, key: messageKey, duration: 2})
      store.teamsAppStore.loading.show({progress: 100});
    }
    if (error.ret && error.ret === 110002) {
      store.appStore.showLoading(false);
      if (store.teamsAppStore.inTeamsApp) {
        message.destroy();
        store.appStore.onShowWarningMessage('', { title: 'PhantomPDF.Online', message: 'teamsApp.collaborationRestricted', }, true);
      } else {
        message.error({content: intl.get('collaboration.Error.hasShared'), key: messageKey, duration: 2})
      }
      store.appStore.setCommonMode();
      store.teamsAppStore.loading.show({progress: 100});
    } else if (error.ret && error.ret === 110016) {
      store.appStore.showLoading(false);
      const errorMsg = intl.get('collaboration.Error.noPermission');
      message.error({content: errorMsg, key: messageKey, duration: 2})
      store.appStore.setCommonMode();
      store.teamsAppStore.loading.show({progress: 100});
    } else if (error.ret && error.ret === 2100023) { // 2100023表示该文档已经被别人创建为协作文档
      if (error.data.isUploading === 1) { // 该文档正在被别人创建中，则等待3秒
        let loop = true
        while(loop) {
          await sleep(3000);
          const shareFileDetails = await collaborationService.getShareReview({ extDocID });
          if(shareFileDetails && shareFileDetails.data[0].isUploading === 0) {
            const createTimeByFoxit = new Date(UTCTimeFormat(shareFileDetails.data[0].createTime)).getTime();
            const { lastModifiedDateTime } = await this.getOneDriveFileInfo();
            const lastModifiedLocalTimeByMSTeams = new Date(UTCTimeFormat(lastModifiedDateTime)).getTime();
            // 通过查询Online服务端接口得知协作已经创建完成，再查询OneDrive接口，得到该文档最近修改时间，如果最近修改时间晚于Online服务端创建协作的时间，则判定该文档已经被别人创建为协作文档并保存回OneDrive了。
            if (lastModifiedLocalTimeByMSTeams > createTimeByFoxit) {
              loop = false;
            }
          }
        }
        store.appStore.showLoading(false);
        message.destroy();
        await this.doAutoOpenOnedriveFileByUrlForTeamsApp();
        return;
      }
      if (error.data.isUploading === 0) { // 该文档已经被别人创建成功，则直接进入别人的协作模式中
        store.appStore.showLoading(false);
        message.destroy();
        let remoteDocHash;
        remoteDocHash = error.data.extDocHash;
        if (!remoteDocHash) {
          const shareFileDetails = await collaborationService.getShareReview({ extDocID });
          remoteDocHash = shareFileDetails.data[0].extDocHash;
        }
        if (remoteDocHash === currentDocHash) {
          const fileLink = error.data.fileLink;
          const fileName = error.data.docName;
          fileController.doOpenFileByUrl(fileLink, fileName);
        } else {
          const sendData = {
            extDocID,
            reviewSessionID: error.data.reviewSessionID,
            delFlag: 1
          }
          await collaborationService.putShareReviewForTeamsApp(sendData)
          const sendDataForCreate = {
            deadline: '',
            prohibitComment: 0,
            extDocID,
            extDocHash: currentDocHash
          };
          await store.collaborationStore.createShareFileLinkForTeamsApp(sendDataForCreate);
        }
        await collaborationService.getAnnotListAll({ reviewSessionID: error.data.reviewSessionID, lastTime: '0000-00-00 00:00:00:000', pageObjNum: '-1', isInitial: true});
        // await collaborationService.renderAnnotInitialTree();
        await collaborationService.openSharedFileForTeamsApp({
          fileLink: error.data.fileLink, 
          reviewSessionID: error.data.reviewSessionID, 
          docName: error.data.docName, 
          cDocID: extDocID
        });
        return;
      }
    }
    else if (error.type == 'noAlert') {
      store.appStore.setCommonMode();
      store.teamsAppStore.loading.show({progress: 100});
    } else {
      store.appStore.setCommonMode();
      console.error("===>>> ~ TeamsAppService ~ failureCallbackOfCreateShareFile ~ error", error);
      store.teamsAppStore.loading.show({progress: 100});
      // const errorMsg = intl.get('UnKnownError');
      // store.collaborationStore.postErrorMsg({ type: 'error', errorInfo: errorMsg });
    }
  }

  async doAutoOpenOnedriveFileByUrlForTeamsApp() {
    store.appStore.showLoadingWithMsg({ show: true, msg: 'teamsApp.downLoadingFile'})
    const teamsFileData = await this.getOneDriveFileInfo();
    const { fileDownloadUrl, fileId, size, fileName } = teamsFileData;
    store.teamsAppStore.setTeamsFileData(teamsFileData);
    const isSizeOver = size / 1024 / 1024 > 30;
    if (isSizeOver) {
      store.teamsAppStore.loading.show({progress: 100});
      message.info("Entering Edit mode, please wait a moment while it is being load...");
      // 分片方式打开文档
      const PDFUI = await store.viewer._getPDFUI();
      const chunk = 1 * 1024 * 1024;
      const docSize = size;
      const docName = fileName;
      const ab = new ArrayBuffer(docSize);
      const blob = new Blob([ab]);
      const file = new window.File([blob], docName, { type: 'application/pdf' });
      store.appStore.showLoading(false);
      PDFUI.openPDFByFile(file, { 
          fileName: docName,
          ReadBlockOption: {
              url: fileDownloadUrl,
              chunk
          }
      });
      // fileController.doOpenFileByUrl(fileDownloadUrl, fileName)
    } else {
      this.onOpenFileForUrlForTeamsApp({url: fileDownloadUrl, fileName, extDocID: fileId});
    }
    locateCommentFromNotification();
  }

  async getOneDriveFileInfo() {
    try {
      return await getFileInfoFromTeams();
    } catch (e) {
      // console.error("getOneDriveFileInfo error:", e);
      // 文件不存在
      fileExit.show({
        content: 'The file does not exist，please contact your admin for assistance.',
        buttonText: 'Refresh Page'
      });
      return Promise.reject(e);
    }
  }

  async onOpenFileForUrlForTeamsApp({url, fileName, extDocID}) {
    const docFromUrl = await getFileBufferByUrl(url)
    const pdfui = await store.viewer._getPDFUI()
    const pdfDoc = await pdfui.pdfViewer.openPDFByFile(docFromUrl, {fileName, isRenderOnDocLoaded: false}).catch((err) => {
      store.teamsAppStore.loading.show({progress: 100});
      store.appStore.showLoading(false);
      message.error({content: `Teams open file error. ${(err&& err.message)?err.message:''}`, key: messageKey, duration: 5});
      let errors = {
        level:'error',
        category:'Teams',
        data:{message: `Teams open file error. ${(err&& err.message)?err.message:''}`, reason: err}
      }
      store.appStore.doPostError(errors);

      throw 'open file error'
    })
    const isCPDF = await isAvailableCPDF();

    if (isCPDF) {
      try {
        const cDocID = await fileController.getCDocID()
        const shareReviewData = await collaborationService.getShareReview({cDocID, getMore: 1})
        if (shareReviewData.ret !== 0) {
          return
        }
        const data = shareReviewData.data[0] || {}
        await collaborationService.openSharedFileForTeamsApp({
          fileLink: data.fileLink, 
          reviewSessionID: data.reviewSessionID,
          docName: data.docName, 
          cDocID: cDocID
        });
        store.appStore.showLoading(false);
      } catch (error) {
        store.appStore.updatePreventDocModifiedFlag(false)
      }
      return;
    }
      store.appStore.updateCurrentClickBtnName(START_SHARE_DOC)
      const checkPassed = await thirdPartyService.checkPermissionAndReflect({addInType: 'Teams'})

      store.appStore.resetCurrentClickBtnName()
      // 无权限的用户使用本地模式打开
      if (!checkPassed) {
        fileController.doOpenFileByUrl(url, fileName, null, true, () => {
          store.appStore.setCommonHeader()
        }).catch(error => {
          throw error;
        })

        store.teamsAppStore.loading.show({progress: 100})

        return
      }

    const buffer = await docFromUrl.arrayBuffer();
    const currentDocHash = await pdfui.pdfViewer.getCurrentPDFDoc().generateDocHash(buffer);
    // 渲染已加载的文件
    await pdfui.pdfViewer.renderDoc(pdfDoc);
    // 该文档是普通文档，但不确定此刻是否被正在被别人创建为协作文档，通过以下方法进入协作模式；
    this.autoEnterCommenting(extDocID, currentDocHash);
  }
}

async function isAvailableCPDF() {
  let isAvailableCPDFDoc = false;
  let cDocID = null;
  const isCPDF = await fileController.isCPDFForCurrentDoc().catch((error) => {
    throw error
  })
  if (isCPDF) {
    cDocID = await fileController.getCDocID();
    if (cDocID) {
      const shareFileDetails = await collaborationService.getShareReview({ cDocID });
      if (shareFileDetails.ret === 0) {
        const fileInfo = shareFileDetails.data[0];
        if (fileInfo) {
          const isCollaborationMode = 0;
          if (fileInfo.shareState === isCollaborationMode && fileInfo.fileLink) {
            isAvailableCPDFDoc = true
          }
        }
      }
    }
  }
  return isAvailableCPDFDoc
}

function sleep(t) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve();
    }, t);
  });
}

export default TeamsAppService;
